import { useEffect, useRef } from 'react'

import _ from 'lodash'
import { Scrollbars } from 'react-custom-scrollbars-2'
import { useWatch } from 'react-hook-form'

import { useResourceContext } from '@/shared/ui/Resource'

export const DigitalProductStoreBottomSheetImages = () => {
  const { image, reward_items } = useResourceContext()
  const selectedVariationId = useWatch({
    name: 'reward_item_id',
    defaultValue: null
  })
  const imageRefs = useRef({})

  useEffect(() => {
    if (selectedVariationId && imageRefs.current) {
      imageRefs.current[selectedVariationId].scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      })
    }
  }, [selectedVariationId, imageRefs])

  return (
    <Scrollbars
      autoHeight
      hideTracksWhenNotNeeded
      autoHide
      renderView={props => (
        <div {...props} style={{ ...props.style, overflow: 'auto' }} />
      )}
    >
      <div className="flex flex-nowrap gap-3">
        <div
          className="bg-no-repeat bg-center bg-cover w-[200px] h-[200px] rounded-lg bg-gray-100 shrink-0"
          style={{
            backgroundImage: `url('${_.get(
              image,
              'file.url',
              '/placeholders/reward.jpg'
            )}')`
          }}
        />
        {reward_items.map((item, index) => (
          <div
            key={index}
            className="bg-no-repeat bg-center bg-cover w-[200px] h-[200px] rounded-lg bg-gray-100 shrink-0"
            ref={el => (imageRefs.current[item.id] = el)}
            style={{
              backgroundImage: `url('${_.get(
                item.image,
                'file.url',
                '/placeholders/reward.jpg'
              )}')`
            }}
          />
        ))}
      </div>
    </Scrollbars>
  )
}
